import { makeStyles } from "@material-ui/styles";

const teamImportStyles = makeStyles(() => ({
	md1: {
		width: "8.3333%"
	},
	md2: {
		width: "16.6666%"
	},
	md3: {
		width: "25%"
	},
	md4: {
		width: "33.3333%"
	},
	tableHead: {
		fontSize: 12,
		letterSpacing: 0.5,
		textTransform: "uppercase",
		lineHeight: "40px"
	}
}));

export default teamImportStyles;
